import SpriteSymbol from "../../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "svg-icon-star-active",
  "use": "svg-icon-star-active-usage",
  "viewBox": "0 0 20 20",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 20 20\" id=\"svg-icon-star-active\"><path d=\"M13.536 5.581l5.387.783c1.03.15 1.442 1.418.696 2.145l-3.898 3.799.921 5.364c.176 1.027-.902 1.81-1.825 1.325L10 16.465l-4.817 2.532c-.923.485-2.001-.298-1.824-1.325l.92-5.364-3.898-3.8c-.746-.726-.334-1.994.696-2.144l5.387-.783L8.872.701c.461-.935 1.795-.935 2.256 0l2.408 4.88z\" fill=\"#FFCB30\" fill-rule=\"nonzero\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol